import React from 'react';
import introVideo from '../assests/Ultra_demo_video.mp4';

const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

function HowToScanVideo() {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '8px 0 40px',
            }}
        >
            <div style={{ textAlign: 'center', maxWidth: 560, marginBottom: 24 }}>
                <h2 style={{ fontSize: 20, fontWeight: 700, color: TEXT_BODY, margin: '0 0 6px' }}>
                    How To Scan
                </h2>
                <p style={{ fontSize: 13.5, color: TEXT_MUTED, margin: 0 }}>
                    Watch this short walkthrough to learn how to perform an accurate scan.
                </p>
            </div>

            <div
                style={{
                    width: '100%',
                    maxWidth: 620,
                    backgroundColor: '#000',
                    borderRadius: '16px',
                    border: `1px solid ${BORDER}`,
                    boxShadow: '0 2px 10px rgba(12, 61, 110, 0.05)',
                    overflow: 'hidden',
                }}
            >
                <video
                    style={{
                        width: '100%',
                        maxHeight: '70vh',
                        display: 'block',
                        objectFit: 'contain',
                        backgroundColor: '#000',
                    }}
                    controls
                >
                    <source src={introVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    );
}

export default HowToScanVideo;